import { render } from "./WhitepaperVesting.vue?vue&type=template&id=3557b1a1&scoped=true"
const script = {}

import "./WhitepaperVesting.vue?vue&type=style&index=0&id=3557b1a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3557b1a1"]])

export default __exports__